import { forwardRef } from "react";

import { isNotNil } from "emoreg/utils";

import { NumberInput, NumberInputProps } from "../number-input";

export type CurrencyInputProps = Omit<NumberInputProps, "after" | "before" | "maxDecimals">;

/** take cents as an input and convert it to euros for display */
export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ value, onChangeValue, ...props }, ref) => {
    return (
      <NumberInput
        ref={ref}
        after={"€"}
        maxDecimals={2}
        value={isNotNil(value) ? value / 100 : null}
        onChangeValue={value => onChangeValue?.(isNotNil(value) ? Math.round(value * 100) : null)}
        {...props}
      />
    );
  }
);

CurrencyInput.displayName = "CurrencyInput";
